import { useQuery } from "@tanstack/react-query";
import { getQueryFn } from "@/lib/queryClient";

export function useAuth() {
  const { data: user, isLoading, error } = useQuery({
    queryKey: ["/api/auth/user"],
    queryFn: getQueryFn({ on401: "returnNull" }),
    retry: false,
    staleTime: 5 * 60 * 1000, // 5 minutes - don't refetch constantly
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchInterval: false,
  });

  const approvalStatus = (user as any)?.approvalStatus || 'pending';
  const isSuperAdmin = (user as any)?.isSuperAdmin === true;
  const isApproved = isSuperAdmin || approvalStatus === 'approved';

  return {
    user,
    isLoading,
    isAuthenticated: !!user,
    approvalStatus,
    isApproved,
    isSuperAdmin,
  };
}
